import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const LaborWelcome = (params) => {
  return (
    <UserInterface>
      <div className="row align-content-center h-100" id="content">
        <div class="welcome-page text-center">
          <img src="/img/labor.png" />
          <h2>Labor</h2>
          <p class="text-center">
            Welcome to GoGMGo Labor module. We will now ask you to take a few
            moments to allow us to help you get acquainted with the module
          </p>

          <a href="#_" class="btn btn-primary">
            Get Started
          </a>
        </div>
      </div>
    </UserInterface>
  );
};
export default LaborWelcome;
